var map = {
	"./ada.svg": 33366,
	"./alert-circle.svg": 30078,
	"./arrow-right.svg": 53051,
	"./arrow-solid.svg": 79424,
	"./bi-header1.svg": 48927,
	"./bi-header2.svg": 29152,
	"./bi-header3.svg": 14403,
	"./bi-header4.svg": 48512,
	"./bit-token.svg": 85591,
	"./btc-token.svg": 52488,
	"./canceled-light.svg": 96349,
	"./canceled.svg": 53429,
	"./card-hot.svg": 36061,
	"./caret-down.svg": 35401,
	"./catalogue.svg": 47558,
	"./close-black.svg": 56193,
	"./close.svg": 95351,
	"./contest-done.svg": 36692,
	"./contest-fail.svg": 80720,
	"./default-img.svg": 81331,
	"./discord.svg": 27098,
	"./down-arrow-white.svg": 43124,
	"./down-arrow.svg": 7603,
	"./edit.svg": 595,
	"./ellipsis-token.svg": 69556,
	"./eth-token.svg": 63470,
	"./expand.svg": 70751,
	"./eye-on.svg": 40043,
	"./facebook.svg": 87912,
	"./fail-icon.svg": 21505,
	"./failure.svg": 89223,
	"./fellow.svg": 19321,
	"./filled.svg": 64309,
	"./filter.svg": 52760,
	"./full-screen.svg": 48759,
	"./github.svg": 98303,
	"./grid-bots-dark.svg": 47305,
	"./grid-bots-light.svg": 99659,
	"./handicap-all-dark.svg": 83998,
	"./handicap-all-light.svg": 73994,
	"./handicap-buy-dark.svg": 81750,
	"./handicap-buy-light.svg": 50165,
	"./handicap-sell-dark.svg": 24836,
	"./handicap-sell-light.svg": 31878,
	"./horn.svg": 7468,
	"./icon-loading.svg": 45193,
	"./instagram.svg": 69973,
	"./launchpad-vip-flag.svg": 63011,
	"./link-to.svg": 29414,
	"./linkedin.svg": 42264,
	"./loan-buy.svg": 87158,
	"./loan-discount.svg": 37200,
	"./loan-lightning.svg": 74878,
	"./loan-paper.svg": 73041,
	"./loan-sawtooth-success.svg": 87619,
	"./loan-success.svg": 43893,
	"./loan-ticket.svg": 63777,
	"./loan-warehousing.svg": 54200,
	"./lp_button_loading.svg": 43276,
	"./lp_button_loading_light.svg": 53024,
	"./lp_subscribe_icon.svg": 33636,
	"./lt-select.svg": 8230,
	"./medal-copper.svg": 53110,
	"./medal-gold.svg": 41296,
	"./medal-silver.svg": 52086,
	"./medium.svg": 56532,
	"./mnt-token.svg": 79492,
	"./mobile/flowers_left.svg": 46957,
	"./mobile/flowers_right.svg": 72279,
	"./more.svg": 61423,
	"./no-data-light.svg": 96000,
	"./no-data.svg": 10486,
	"./order.svg": 50428,
	"./pending.svg": 90672,
	"./progress-icon.svg": 91688,
	"./reddit.svg": 62390,
	"./search-no-data.svg": 59182,
	"./search.svg": 99098,
	"./settings.svg": 99407,
	"./share-orange.svg": 12356,
	"./share.svg": 52987,
	"./spot-copytrading.svg": 41145,
	"./spot-standard.svg": 47112,
	"./stranded-dark.svg": 39375,
	"./stranded-light.svg": 95310,
	"./subscribe_dialog_close.svg": 85378,
	"./telegram.svg": 27166,
	"./trade_off.svg": 54835,
	"./twitter.svg": 63555,
	"./upgrade-icon.svg": 29570,
	"./usdc-token.svg": 52929,
	"./usdt-token.svg": 60763,
	"./user-center.svg": 49155,
	"./vote-share.svg": 99994,
	"./vote_button_loading.svg": 74695,
	"./vote_button_loading_light.svg": 66969,
	"./warning.svg": 71197,
	"./youtube.svg": 26975
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40240;